/* eslint-disable no-void */

import * as vp from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '../../services/api.config';

const { api } = vopayApi;

export function useSaveAccountUserPermissions(bearer?: string) {
  const source = axios.CancelToken.source();

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function saveAccountUserPermissions(params: vp.AccountUserPermissionsPostRequest, bearerOverride?: string) {
    try {
      setLoading(true);
      const res = await api.postAccountUserPermissions(params, bearerOverride ?? bearer, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      return res;
    } catch (err) {
      console.error(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }

  return {
    loading,
    saveAccountUserPermissions,
  };
}
export default useSaveAccountUserPermissions;
